// extracted by mini-css-extract-plugin
export var container = "Address_container__-Lez8";
export var header = "Address_header__9wJaB";
export var modal = "Address_modal__M8nEX";
export var title = "Address_title__3BFUB";